export default __webpack_public_path__ + "static/media/asset4.4c969676.png";